import { Fragment, useContext, useEffect, useState } from 'react';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { Avatar, Box, IconButton, Stack, styled, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { SidebarContext } from 'src/contexts/SidebarContext';
import type { RootState } from 'src/redux/store';
import { useLocation, useNavigate } from 'react-router-dom';
import HeaderUserbox from './Userbox';
import {
  setSiteId,
  setLoader,
  setSiteAuditRefresh,
  setReAuditCheck,
  setSiteStatus,
  setRestrictReAuditModal
} from 'src/redux/siteAuditReducer';
import CommonModal from 'src/common/config/CommonModal';
import React from 'react';
import SiteAuditModal from 'src/content/siteAudit/SiteAuditModal';
import {
  getAuthenticated,
  sanitizeURL
} from 'src/common/config/FunctionHelper';
import { setIsDeleteSlot } from 'src/redux/userManagementReducer';
import UpgradeModalForSiteAudit from 'src/content/siteAudit/UpgradeModalForSiteAudit';
import { paths } from 'src/common/config/TextMessage';
import { setBlogPostGsc } from 'src/redux/keywordResearch';
import { headerSx } from 'src/common/CommomSxs';
/**
 * CSS-in-JS styles for the HeaderWrapper component.
 * This styles the header with specific properties such as height, color, and positioning.
 *
 * @param {object} theme - The theme object used for styling.
 */
const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: 63px;
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        padding-left: 0;
        right: 0;
        z-index: 6;
        background-color: var(--color-white);
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            left: 250px;
            width: auto;
        }
`
);

const MenuProps = {
  PaperProps: {
    style: {
      // maxHeight: window.innerHeight - 150,
      maxHeight: 500, // Adjust this value as needed
      overflow: 'auto',
      width: 275,
      borderRadius: '4px',
      boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.06)'
    }
  },
  disableScrollLock: true
};

/**
 * A component representing the header of the application.
 * It contains elements such as navigation, audit site selection, and premium user features.
 *
 * @returns {JSX.Element} The Header component.
 */
const Header = () => {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const dispatch = useDispatch();

  const [selectedValue, setSelectedValue] = useState('');
  const [auditSiteDetailes, setAuditSiteDetailes] = useState([]);
  const [siteDetailUpdates, setSiteDetailUpdates] = useState(null);
  const [openSiteAudit, setOpenSiteAudit] = useState(false);
  const [disableDropdown, setDisableDropdown] = useState(true);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  let sitesDetail =
    useSelector((state: RootState) => state.counter.sitesDetails) ?? {};
  let siteAuditRefresh = useSelector(
    (state: RootState) => state.siteAudit.siteAuditRefresh
  );


  let reAuditCheck =
    useSelector((state: RootState) => state.siteAudit.reAuditCheck) ?? 0;

  const siteId = useSelector((state: RootState) => state.siteAudit.siteId) ?? 0;
  const isDeleteSlot =
    useSelector((state: RootState) => state.userManagement.isDeleteSlot) ??
    false;

  let stripeSubscriptionDetails = useSelector(
    (state: RootState) => state.user.subscription
  );
  let scanDetailRedux = useSelector(
    (state: RootState) => state.counter.scanDetails
  );
  let blogPostGsc = useSelector(
    (state: RootState) => state.keywordResearch.blogPostGsc
  );
  const navigate = useNavigate();
  const location = useLocation();


  /**
   * Closes the site audit modal.
   */
  const handleSiteAuditModalClose = () => {
    setOpenSiteAudit(false);
    dispatch(setRestrictReAuditModal(true));
  };

  /**
   * Sets the state to open or close the site audit modal.
   *
   * @param {boolean} arg0 - A boolean to indicate if the site audit modal should be opened.
   */
  const setOpenAddScan = (arg0: boolean): void => {
    setOpenSiteAudit(arg0);
  };

  /**
   * Fetches and sets the list of audit sites.
   */
  const setAudiSiteList = async () => {};

  useEffect(() => {
    if (isDeleteSlot) {
      setAudiSiteList();
      dispatch(setIsDeleteSlot(false));
    }
    return () => {};
  }, [isDeleteSlot]);

  useEffect(() => {
    if (auditSiteDetailes?.length == 0 || !auditSiteDetailes?.length) {
      dispatch(setSiteStatus(false));
    }
    if (auditSiteDetailes?.length) {
      let getLastSelectedSite = localStorage.getItem('lastSelectedSite');
      let selectedSiteAuditDetails = auditSiteDetailes[0];

      if (getLastSelectedSite != null) {
        let lastSelectedSite = JSON.parse(getLastSelectedSite);
        if (
          lastSelectedSite?.length > 0 &&
          auditSiteDetailes?.find((item) => item._id === lastSelectedSite[1])
        ) {
          setSelectedValue(
            sanitizeURL(lastSelectedSite[0]) + '&&' + lastSelectedSite[1]
          );
          dispatch(setLoader(true));
          checkAuditStatus(lastSelectedSite[1]);
        } else {
          setSelectedValue(
            sanitizeURL(selectedSiteAuditDetails.url) +
              '&&' +
              selectedSiteAuditDetails._id
          );
          dispatch(setLoader(true));
          checkAuditStatus(selectedSiteAuditDetails._id);
          let values = [
            selectedSiteAuditDetails.url,
            selectedSiteAuditDetails._id
          ];
          localStorage.setItem('lastSelectedSite', JSON.stringify(values));
        }
      } else {
        setSelectedValue(
          sanitizeURL(selectedSiteAuditDetails.url) +
            '&&' +
            selectedSiteAuditDetails._id
        );
        dispatch(setLoader(true));
        checkAuditStatus(selectedSiteAuditDetails._id);
        let values = [
          selectedSiteAuditDetails.url,
          selectedSiteAuditDetails._id
        ];
        localStorage.setItem('lastSelectedSite', JSON.stringify(values));
      }
    }
  }, [auditSiteDetailes?.length]);

  /**
   * Handles the change of the selected audit site.
   *
   * @param {object} event - The event object.
   */
  const handleChange = (event: any) => {
    let values = event.target.value.split('&&');
    localStorage.setItem('lastSelectedSite', JSON.stringify(values));
    dispatch(setLoader(true));
    setSelectedValue(event.target.value);
    dispatch(setSiteId(values[1]));
    checkAuditStatus(values[1]);
  };

  /**
   * Checks the audit status of a site.
   *
   * @param {string} siteid - The ID of the site to check.
   */
  const checkAuditStatus = async (siteid) => {};

  useEffect(() => {
    (async () => {
      const isAuthenticated: any = getAuthenticated();
      if (isAuthenticated !== 'false') {
        setAudiSiteList();
      }
    })();

    return () => {};
  }, []);

  useEffect(() => {
    (async () => {
      if (reAuditCheck === true) {
        checkAuditStatus(siteId);
        dispatch(setReAuditCheck(false));
      }
    })();

    return () => {};
  }, [reAuditCheck === true]);

  useEffect(() => {
    if (blogPostGsc) {
      setAudiSiteList();
      dispatch(setBlogPostGsc(null));
    }
    if (siteDetailUpdates && siteId?.length > 0) {
      checkAuditStatus(siteId);
      setSiteDetailUpdates(null);
      dispatch(setBlogPostGsc(null));
    }
  }, [blogPostGsc, siteDetailUpdates]);

  useEffect(() => {
    (async () => {
      if (siteAuditRefresh) {
        setAudiSiteList();
        dispatch(setSiteAuditRefresh(false));
      }
    })();

    return () => {};
  }, [sitesDetail['sites'], siteAuditRefresh]);

  useEffect(() => {
    if (
      location.pathname === paths.siteAudit ||
      location.pathname === paths.seoTasks ||
      location.pathname.includes(paths.keywordResearch) ||
      location.pathname.includes(paths.orbitAiAgent)
    ) {
      setDisableDropdown(false);
    } else {
      setDisableDropdown(true);
    }

    return () => {
      setDisableDropdown(false);
    };
  }, [location.pathname]);

  const handleCloseUpgradeModal = () => {
    setShowUpgradeModal(false);
  };

  const openModal = () => {
    if (
      parseInt(scanDetailRedux?.['useScan'], 10) >=
      parseInt(scanDetailRedux?.['scan'])
    ) {
      setShowUpgradeModal(true);
    } else {
      // setOpenAddScan(true);
      navigate(paths?.onBoarding);
    }
  };

  let selectedSiteSqSp =
    useSelector((state: RootState) => state.siteAudit.siteAuditSite) || null;

  const getHostname = (url) => {
    if (!url) return null;

    let hostname = url.replace(/^https?:\/\//, '');
    hostname = hostname.replace(/^www\./, '');

    return hostname;
  };

  const normalizedSelectedSite = getHostname(selectedSiteSqSp);

  /**
   * Effect hook that checks if a selected site URL exists in the audit site details array.
   * If it exists, stores the site's URL and ID in localStorage.
   *
   * @param {Array} auditSiteDetailes - Array of site details with URLs.
   * @param {string} selectedSiteSqSp - URL of the selected site.
   * @param {any} selectedValue - Dependency value to trigger the effect.
   */
  useEffect(() => {
    if (
      normalizedSelectedSite &&
      Array.isArray(auditSiteDetailes) &&
      auditSiteDetailes?.length > 0
    ) {
      const selectedSite = auditSiteDetailes?.find((item) => {
        const normalizedUrl = getHostname(item.url);
        return normalizedUrl === normalizedSelectedSite;
      });
      if (selectedSite) {
        checkAuditStatus(selectedSite?._id);
        const values = [selectedSite?.url, selectedSite?._id];
        // Store the selected site's URL and ID in localStorage
        localStorage.setItem('lastSelectedSite', JSON.stringify(values));
        setSelectedValue(
          sanitizeURL(selectedSite.url) + '&&' + selectedSite._id
        );
        // dispatch(setSiteAuditSite(null));
      }
    }
  }, [normalizedSelectedSite, auditSiteDetailes]);

  return (
    <Fragment>
      <HeaderWrapper
        display="flex"
        alignItems="center"
        sx={headerSx.headerWrapper}
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          flex={1}
          height="100%"
          sx={
            !stripeSubscriptionDetails?.subscription_id
              ? { visibility: 'hidden' }
              : { visibility: 'visible' }
          }
        >

        </Stack>
        <Box display="flex" height="100%" alignItems="center" sx={{ flexShrink: 0 }}>
          <HeaderUserbox />
          <Box component="span" sx={headerSx.sidebarToggleBox}>
            <Tooltip arrow title="Toggle Menu">
              <IconButton color="primary" onClick={toggleSidebar}>
                {!sidebarToggle ? (
                  <MenuTwoToneIcon fontSize="small" />
                ) : (
                  <CloseTwoToneIcon fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </HeaderWrapper>
      <CommonModal
        open={openSiteAudit}
        handCloseModal={handleSiteAuditModalClose}
        title={
          <React.Fragment>
            <Avatar
              src={process.env.PUBLIC_URL + '/static/images/logo/new-logo.svg'}
              alt="Logo"
              sx={headerSx.siteAuditModalBtn}
            />
          </React.Fragment>
        }
        closebtn={false}
      >
        <SiteAuditModal handleAddScanModalClose={handleSiteAuditModalClose} />
      </CommonModal>

      <UpgradeModalForSiteAudit
        showUpgradeModal={showUpgradeModal}
        setShowUpgradeModal={setShowUpgradeModal}
        handleCloseUpgradeModal={handleCloseUpgradeModal}
      />
    </Fragment>
  );
};

export default Header;
